/* NEWGARDEN contact enquiries. Uses the Google & YouTube app's existing gtag.
   No Google loader, purchase mapping, or customer-field collection is added. */
(function () {
  'use strict';
  var destination = 'AW-18416771833/s5tkCOqBrOocEPnF5s1E';
  document.querySelectorAll('[data-newgarden-contact]').forEach(function (container) {
    var form = container.querySelector('form');
    if (!form || form.dataset.newgardenTrackingBound) return;
    form.dataset.newgardenTrackingBound = 'true';
    var key = 'newgarden:lead:' + container.dataset.newgardenContact;
    var storageOK = true;
    function read() {
      try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
      catch (e) { storageOK = false; return null; }
    }
    function write(value) {
      try { sessionStorage.setItem(key, JSON.stringify(value)); }
      catch (e) { storageOK = false; }
    }
    function token() {
      return 'ng-' + (window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
    }
    form.addEventListener('submit', function () {
      write({ id: token(), at: Date.now(), state: 'submitted' });
    });
    if (!container.querySelector('[data-newgarden-success]')) return;
    var pending = read();
    // A copied success URL or a refresh must not manufacture another lead.
    if (storageOK && (!pending || pending.state !== 'submitted' ||
        Date.now() - pending.at > 1800000 || Date.now() < pending.at)) {
      container.dataset.newgardenTracking = 'no-new-submission';
      return;
    }
    pending = pending || { id: token(), at: Date.now(), state: 'submitted' };
    var sent = false;
    var timer;
    var deadline;
    var privacyRequested = false;
    function attempt() {
      if (sent) return;
      var shopify = window.Shopify;
      var privacy = shopify && shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== 'function') {
        container.dataset.newgardenTracking = 'waiting-for-privacy';
        if (!privacyRequested && shopify && typeof shopify.loadFeatures === 'function') {
          privacyRequested = true;
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
            if (!error) attempt();
          });
        }
      } else if (!privacy.marketingAllowed()) {
        container.dataset.newgardenTracking = 'waiting-for-consent';
      } else if (typeof window.gtag !== 'function') {
        container.dataset.newgardenTracking = 'waiting-for-google-tag';
      } else {
        window.gtag('event', 'conversion', {
          send_to: destination,
          value: 1.0,
          currency: 'AUD',
          transaction_id: pending.id
        });
        sent = true;
        pending.state = 'queued';
        write(pending);
        container.dataset.newgardenTracking = 'queued';
        clearTimeout(timer);
        document.removeEventListener('visitorConsentCollected', start);
        return;
      }
      if (!sent && Date.now() < deadline) timer = setTimeout(attempt, 250);
    }
    function start() {
      clearTimeout(timer);
      deadline = Date.now() + 60000;
      attempt();
    }
    document.addEventListener('visitorConsentCollected', start);
    start();
  });
})();
